module.exports = __webpack_public_path__ + "img/i2.154aa64a.png";